'use client';

import { Button } from '@mokoboko/components';

import { useRetryReads } from '@/hooks/use-retry-reads';
import { mergeClassNames } from '@/lib/utils';

// A read that failed says so; it never renders as an empty account. Retries
// are off at the client default, so the only action is this button.
export const FailedReadNotice = ({
  message,
  className,
  onGround = false,
}: {
  message: string;
  className?: string;
  // Straight on the page background rather than on a card.
  onGround?: boolean;
}) => {
  const { retry, isRetrying } = useRetryReads();

  return (
    <div
      role="alert"
      className={mergeClassNames(
        'flex flex-col items-center gap-1 py-4 text-center text-sm',
        onGround ? 'on-ground text-ground-body' : 'text-gray-700',
        className
      )}
    >
      {message}
      <Button
        variant="link-color"
        size="sm"
        className={mergeClassNames(
          'text-sm font-semibold',
          onGround && 'text-ground-link hover:text-ground-link-hover'
        )}
        isProcessing={isRetrying}
        onClick={retry}
      >
        Try again
      </Button>
    </div>
  );
};
